import { ThemeProvider, createTheme } from "@mui/material/styles";
import type {} from "@mui/lab/themeAugmentation";
import "@mui/lab/themeAugmentation";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import { CustomDateRangePicker } from "../../components/CustomDateRangePicker";
import Modal from "../../components/Modal";
import { ClickableIcon } from "../../components/Icon";
import styled from "styled-components";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ConfirmButton } from "../../components/Button";
import dayjs from "dayjs";
type Props = {
  isOpen: boolean;
  setOpen?: any;
  status: string;
  defaultStartDate?: any;
  semesterStartDate: string | number | Date;
  semesterEndDate: string | number | Date;
  defaultEndDate?: any;
  startDate: any;
  endDate: any;
  setStartDate: any;
  setEndDate: any;
  onConfirm: (startDateDisabled: boolean) => void;
  title: string;
};
const CustomFlex = styled(FlexBox)`
  margin-bottom: 20px;
  align-items: flex-start;
`;
const Header = styled.h4`
  font-family: Montserrat;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;

export default function EditModal({
  isOpen,
  setOpen,
  status,
  semesterEndDate,
  semesterStartDate,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  title,
  onConfirm,
}: Props) {
  const disableStart = (date: any, status: string) => {
    const today = new Date();
    const actualDate = new Date(date);
    if (actualDate && today && status) {
      if (actualDate.getTime() < today.getTime() || status !== "Planned") {
        return true;
      }
    }
    return false;
  };
  return (
    <Modal
      isOpen={isOpen || false}
      setOpen={setOpen}
      customStyle={{
        content: {
          maxWidth: "1000px",
          padding: 20,
          background: "#090d20",
          // border: "1px solid #2D416C",
          boxShadow: "0px 4px 16px rgba(0,0,0)",
          borderRadius: "8px",
          marginTop: 30,
        },
      }}
    >
      <CustomFlex>
        <FlexGrow>
          <Header>{title}</Header>
        </FlexGrow>
        <ClickableIcon name="times" onClick={() => setOpen(false)} />
      </CustomFlex>
      <CustomDateRangePicker
        startDate={dayjs(startDate).format("YYYY-MM-DD")}
        endDate={dayjs(endDate).format("YYYY-MM-DD")}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <FlexBox justify="end" style={{ paddingTop: 20 }}>
        <ConfirmButton
          disabled={true}
          onClick={() => {
            onConfirm(disableStart(startDate, status));
          }}
        >
          Confirm
        </ConfirmButton>
      </FlexBox>
    </Modal>
  );
}
